var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "info_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#info_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.168 14.166h1.667v-5H9.168v5zm.833-6.667c.236 0 .434-.08.594-.24.16-.159.24-.357.24-.593a.806.806 0 00-.24-.594.807.807 0 00-.594-.24.806.806 0 00-.593.24.806.806 0 00-.24.594c0 .236.08.434.24.594.16.16.357.24.593.24zm0 10.834a8.115 8.115 0 01-3.25-.657 8.415 8.415 0 01-2.646-1.78 8.416 8.416 0 01-1.78-2.647A8.114 8.114 0 011.667 10c0-1.152.219-2.236.656-3.25a8.415 8.415 0 011.781-2.645 8.415 8.415 0 012.646-1.782 8.115 8.115 0 013.25-.656c1.153 0 2.236.219 3.25.656a8.415 8.415 0 012.646 1.782 8.416 8.416 0 011.781 2.645 8.115 8.115 0 01.657 3.25 8.114 8.114 0 01-.657 3.25 8.416 8.416 0 01-1.78 2.646 8.415 8.415 0 01-2.647 1.781 8.115 8.115 0 01-3.25.657zm0-1.667c1.861 0 3.438-.646 4.73-1.938 1.291-1.291 1.937-2.867 1.937-4.729 0-1.86-.646-3.437-1.938-4.729-1.291-1.291-2.868-1.937-4.729-1.937-1.86 0-3.437.646-4.729 1.937C3.98 6.562 3.335 8.138 3.335 10c0 1.86.645 3.437 1.937 4.729 1.292 1.291 2.868 1.937 4.73 1.937z",
    fill: "currentColor"
  }))));
}
export default SvgInfo;